<template>
	<v-container>
	  <v-row justify="center" class="mb-10">
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" class="pb-1">
	  		<v-card class="elevation-0 transparent">
	  			<v-card-text>
						<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Lecciones
            </div>
	  			</v-card-text>
	  		</v-card>
	  	</v-col>


	  	<v-col cols="12" sm="6" md="6" lg="5">
	  		<!-- cODIGO DE CERFTIFICACIÓN -->
	  		<v-card class="codigoCertificacion" @click="verCodigoCertificacion( )" v-if="visibleCodigo">
	  			<v-card-text class="mb-0 font-weight-bold text-h6 text-center white--text mb-4">
            CODIGO
	  			</v-card-text>
	  		</v-card>

		    <v-expansion-panels>
		      <v-expansion-panel v-for="(leccion, i) in getRecursosGrupoUsuario" :key="i">
		        <v-expansion-panel-header disable-icon-rotate>
		        	<!-- Titulo -->
		          <v-list-item class="px-2">
				        <v-list-item-content>
				          <v-list-item-title>
				            {{ leccion.leccion }}
				          </v-list-item-title>
				          <v-list-item-subtitle v-if="leccion.abrir == 1 && tieneCalificacion(leccion.calificacion)">Ejercicio realizado</v-list-item-subtitle>
				          <v-list-item-subtitle v-if="leccion.abrir == 1 && !tieneCalificacion(leccion.calificacion)">Ejercicio faltante</v-list-item-subtitle>
				          <v-list-item-subtitle v-if="leccion.abrir == 2">Disponible a partir del: {{ leccion.fecha }}</v-list-item-subtitle>
				        </v-list-item-content>
				      </v-list-item>

				      <!-- Estatus -->
		          <template v-slot:actions>
			          <v-avatar
			            size="40"
			            color="transparent"
			            rounded
			            :class="`elevation-1 avatares ${ getSymbolLeccion( leccion.abrir, leccion.calificacion, 1, i) }`"
			          >
			            <v-icon color="white" v-text="getSymbolLeccion( leccion.abrir, leccion.calificacion, 2, i)">mdi-check</v-icon>
			          </v-avatar>
		          </template>

		        </v-expansion-panel-header>


		        <!-- Panel informativo -->
		        <v-expansion-panel-content >
		        	<v-divider></v-divider>
							<!-- Lecciones que si se pueden abrir -->
		        	<v-card-actions class="pt-4" v-if="visibleRecurso( leccion, i )">
			        	<!-- Ejercicios antes de la lección 20 -->
		        		<v-row v-if="i < (getRecursosGrupoUsuario.length - 1)">
		        			<!-- Ejercicio -->
		        			<v-col cols="3" 
		        				v-if="leccion.ejercicios > 0"
		        				class="px-0"
		        				align="center"
		        			>
				        		<v-card 
			        				@click="abrirRecurso(leccion.recursos, 1, 1 )"
			        				width="42" 
			        				height="42" 
			        				class="elevation-0 transparent"
										>
											<v-img src="@/assets/iconos/documento.svg"></v-img>
										</v-card>
										<span class="text-caption">Ejercicio</span>
		        			</v-col>

		        			<!-- PDFS -->
		        			<v-col cols="3" 
		        				v-if="leccion.pdfs > 0"
		        				class="px-0"
		        				align="center"
		        			>
		        				<v-card 
			        				@click="abrirRecurso(leccion.recursos, 3, 4 )"
			        				width="42" height="42" class="elevation-0 transparent">
											<v-img src="@/assets/iconos/pdf.svg" ></v-img>
										</v-card>
										<span class="text-caption">PDF</span>
		        			</v-col>

		        			<!-- Videos -->
		        			<v-col cols="3" 
		        				v-if="leccion.videos > 0"
		        				class="px-0"
		        				align="center"
		        			>
		        				<v-card 
			        				@click="abrirRecurso(leccion.recursos, 4, 5 )"
			        				width="42" height="42" class="elevation-0 transparent">
											<v-img src="@/assets/iconos/youtube.svg" ></v-img>
										</v-card>
										<span class="text-caption">Video</span>
		        			</v-col>
		        		</v-row>

		        		<!-- leccion 20, debe tener una calificación arriba de 75 en la lección anterior -->
		        		<v-row v-if="i == (getRecursosGrupoUsuario.length - 1) && getRecursosGrupoUsuario[i - 1].calificacion >= 75">
		        			<!-- Ejercicio -->
		        			<v-col cols="3" 
		        				v-if="leccion.ejercicios > 0"
		        				class="px-0"
		        				align="center"
		        			>
				        		<v-card 
			        				@click="abrirRecurso(leccion.recursos, 1, 1 )"
			        				width="42" 
			        				height="42" 
			        				class="elevation-0 transparent"
										>
											<v-img src="@/assets/iconos/documento.svg"></v-img>
										</v-card>
										<span class="text-caption">Ejercicio</span>
		        			</v-col>

		        			<!-- PDFS -->
		        			<v-col cols="3" 
		        				v-if="leccion.pdfs > 0"
		        				class="px-0"
		        				align="center"
		        			>
		        				<v-card 
			        				@click="abrirRecurso(leccion.recursos, 3, 4 )"
			        				width="42" height="42" class="elevation-0 transparent">
											<v-img src="@/assets/iconos/pdf.svg" ></v-img>
										</v-card>
										<span class="text-caption">PDF</span>
		        			</v-col>

		        			<!-- Videos -->
		        			<v-col cols="3" 
		        				v-if="leccion.videos > 0"
		        				class="px-0"
		        				align="center"
		        			>
		        				<v-card 
			        				@click="abrirRecurso(leccion.recursos, 4, 5 )"
			        				width="42" height="42" class="elevation-0 transparent">
											<v-img src="@/assets/iconos/youtube.svg" ></v-img>
										</v-card>
										<span class="text-caption">Video</span>
		        			</v-col>
		        		</v-row>

		        		<!-- Lección 20, con una calificación menor a 75 -->
		        		<v-row v-if="i == (getRecursosGrupoUsuario.length - 1) && getRecursosGrupoUsuario[i - 1].calificacion < 75">
		        			<v-col cols="12">
		        				<v-alert type="warning">
					        		Hola, {{ getUsuarioLMS.nombre_completo }} <br/><br/>
					        		Para poder acceder a tu último examen, es necesario obtener una calificación mayor a 75 en tu lección anterior.<br/>
					        		Por favor, vuelve a ver tus videos y realiza tus ejercicios para poder obtener una máxima calificación. <br/><br/>
					        		<v-avatar
					        		  size="70"
					        		  color="white"
					        		>
					        			<v-img src="@/assets/iconos/trebol.png" width="70"></v-img>
					        		</v-avatar>
					        	</v-alert>
		        			</v-col>
		        		</v-row>
		        	</v-card-actions>

		        	<!-- Alertas para indicar que no se pueden abrir todavía -->
		        	<v-alert type="info" v-else-if="i < (getRecursosGrupoUsuario.length - 1)">
		        		Para habilitar este ejercicio es necesario contestar el anterior
		        	</v-alert>

		        	<!-- Alerta para indicar los requisitos de la lección 20 -->
		        	<v-alert type="info" v-else-if=" i == (getRecursosGrupoUsuario.length - 1)">
		        		Requisitos: <br/>
		        		<ul>
		        			<li>Responder la lección anterior</li>
		        			<li>Obtener una calificación mayor a 75 en la lección 19</li>
		        		</ul>
		        	</v-alert>
		        		
		        	</v-card-actions>

		        </v-expansion-panel-content>

		      </v-expansion-panel>
		    </v-expansion-panels>
	  	</v-col>
	  </v-row>

	  <v-speed-dial
      top
      left
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          :to="{name: 'DetalleGrupo'}"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	  <Alerta         v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader         v-if="cargar"          :loader="loader"/>
	  <CodigoCerti    v-if="verCodigo"       :codigo="codigo"/>

	</v-container>
</template>
<script>

	// importar librerías
	import { mapGetters, mapActions } from 'vuex'
	const  base64 = require('base-64');
	
	// Componentes
  import Alerta      from '@/components/alertas/Alerta.vue'
  import Loader      from '@/components/alertas/Loader.vue'
  import CodigoCerti from '@/components/grupos/CodigoCerti.vue'

	export default {
	  name: "dashboard-default",
	  data: () => ({
	  	show: false,

    	respuestaAlerta: false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},


     	verCodigo: false,
			codigo:{
				estatus: false
			},

     	visibleCodigo: false

	  }),

	  components: {
	    Alerta,
	    Loader,
	    CodigoCerti
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getRecurso' ])
	  },

	  created ( ){
	  	// Necesitamos ver si la alumna o alumno ya pueden tener el codigo, para esooo, es necesario haber contestado todos sus ejerciciossss
	  	// Guardamos la longitud de los recursos
	  	const longitud = ( this.getRecursosGrupoUsuario.length - 1 )
	  	// Validamos la calificación de la última lección
	  	/*
				NOTA: recordemos que para llegar a esta lección, ya se realizaron todas las anteriores y además, se evaluaron las calificaciones
	  	*/
	  	if( this.tieneCalificacion( this.getRecursosGrupoUsuario[ longitud ].calificacion ) ){
	  		// Si tiene calificación, dejamos ver el codigo
	  		this.visibleCodigo = true
	  	}
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirVentanaRecurso'] ),

	  	tieneCalificacion( calificacion ){
	  		return calificacion !== null && calificacion !== undefined && calificacion !== ''
	  	},

	  	getSymbolLeccion( abrir, calificacion, type, position ){
	  		const prevOk = position > 0 && this.tieneCalificacion( this.getRecursosGrupoUsuario[ position - 1 ].calificacion )
	  		if( abrir == 1 && position === 0 ){
	  			return this.tieneCalificacion( calificacion )
	  				? ( type == 1 ? 'shadowCardCheck' : 'mdi-check' )
	  				: ( type == 1 ? 'shadowCardAlerta' : 'mdi-alert' )
	  		}
	  		if( abrir == 1 && prevOk && this.tieneCalificacion( calificacion ) ){
	  			return type == 1 ? 'shadowCardCheck' : 'mdi-check'
	  		}
	  		if( abrir == 1 && prevOk && !this.tieneCalificacion( calificacion ) ){
	  			return type == 1 ? 'shadowCardAlerta' : 'mdi-alert'
	  		}
	  		return type == 1 ? 'shadowCardCalendar' : 'mdi-clock'
	  	},

	  	abrirRecurso ( recursos, ventana, tipo ){
	  		const recursosPorAbrir = recursos.filter( el=> { return el.tipo == tipo })
	  		const payload = {
	  			recursosPorAbrir,
	  			ventana
	  		}
	  		// Abrir la ventana, mandar los recursos y mandar que ventana se abrirá
	  		this.abrirVentanaRecurso( payload )
	  	},

	  	visibleRecurso ( leccion, i) {
	  		// Si la posición es 0, ya se puede realizar
	  		if( i == 0 ){
	  			return true
	  		}else{
	  			// Si la lección anterior ya tiene calificación y ya se puede abrir el recurso, adelante
	  		if( this.tieneCalificacion( this.getRecursosGrupoUsuario[ i - 1 ].calificacion ) && leccion.abrir ){
	  				return true
	  			}else{
	  				// Si la anterior no se ha realizado o no se puede abrir aún, no la abrimos
	  				return false
	  			}
	  		}
	  	},

	  	verCodigoCertificacion( ){
				this.cargar = true
	  		// encriptamos el id
	  		const id_alumno = base64.encode( this.getUsuarioLMS.id )

	  		this.$http.get('codigo.certificacion/' + id_alumno).then( response => {
		  		this.codigo.estatus         = true
		  		this.codigo['codigo']       = response.body.codigo
		  		this.codigo['username']     = response.body.username
		  		this.codigo['pass']         = response.body.pass
		  		this.codigo['institucion']  = response.body.institucion
		  		this.codigo['manual']       = response.body.manual
		  		this.codigo['ruta']         = response.body.ruta
		  		this.codigo['ruta_archivo'] = response.body.ruta_archivo
		  		this.verCodigo      = true

	  		}).catch( error =>{
    			this.cargar = false
    			if( error.status == 400 || error.status == 500 ){
      			this.parametros.mensaje      = error.body.message
	  				this.parametros.color        = '#FF2C2C'
      			this.parametros.dialogError  = true 
      			this.respuestaAlerta = true 
      		}
    		}).finally( () => { this.cargar = false })
	  	}
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCardCalendar{
		border-radius: 50px !important; 
		background: rgb(101,101,101);
		background: linear-gradient(90deg, rgba(101,101,101,1) 0%, rgba(210,208,206,1) 100%);
	}

	.shadowCardAlerta{
		border-radius: 50px !important; 
		background: rgb(255,106,0);
		background: linear-gradient(90deg, rgba(255,106,0,1) 0%, rgba(255,179,103,1) 100%);
	}

	.shadowCardCheck{
		border-radius: 50px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}
	
	.colorCurso{
		color: #006093;
	}
</style>
